import { ID } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { FCAdditionalProps } from "@datassential/platform-ui-lib/lib/core/models";
import React, { ReactNode } from "react";

interface ITabItem<I extends ID = ID, T extends ReactNode = string> {
    id: I;
    title: T;
}

type Modifier = 'test';

type Props<I extends ID, T extends ReactNode = string> = FCAdditionalProps & {
    data: ITabItem<I, T>[];
    activeTabId: I;
    onItemClick: (id: I) => void;
    modifiers?: Modifier[];
}

const LineTabs = <I extends ID = ID, T extends ReactNode = string>({
    data,
    activeTabId,
    onItemClick,
    modifiers = [],
    testId,
    className,
    ...rest
}: Props<I, T>) => {
    return (
        <div
            className={cn(
                className,
                "LineTabs",
                ...modifiers.map(i => `is-${i}`),
            )}
            data-testid={testId}
            {...rest}
        >
            {data.map(({ id, title }, index) => (
                <React.Fragment key={id}>
                    <div
                        className={`LineTabs__item ${activeTabId === id ? 'is-active' : ''}`}
                        onClick={() => onItemClick(id)}
                        data-testid={`buttonLineTabsItem${index}`}
                        >
                        {title as ReactNode}
                    </div>
                    {index !== data.length - 1 && <div className="LineTabs__divider" />}
                </React.Fragment>
            ))}
        </div>
    );
}

export default LineTabs;